import React, { useState } from 'react';
import { MapContainer, TileLayer, CircleMarker, Popup } from 'react-leaflet';
import { StoreDetailPanel } from './StoreDetailPanel';
import { MapLegend } from './MapLegend';
import { stores } from '../../data/stores';
// Status colors
const statusColors = {
  success: '#639754',
  warning: '#FFF000',
  danger: '#DF0000'
};
// Export stores for use in other components
export { stores };
export function StoreMap() {
  const [selectedStore, setSelectedStore] = useState<any>(null);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const handleMarkerClick = (store: any) => {
    setSelectedStore(store);
    setIsPanelOpen(true);
  };
  return <div className="relative w-full h-full bg-gray-100 overflow-hidden" data-id="element-215">
      <MapContainer center={[51.1657, 10.4515]} zoom={6.5} style={{
      height: '100%',
      width: '100%'
    }} zoomControl={true} data-id="element-216">
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" data-id="element-217" />

        {stores.map(store => <CircleMarker key={store.id} center={[store.lat, store.lng]} radius={10} pathOptions={{
        fillColor: statusColors[store.status as keyof typeof statusColors],
        fillOpacity: 0.9,
        color: '#ffffff',
        weight: 3
      }} eventHandlers={{
        click: () => handleMarkerClick(store)
      }} data-id="element-218">
            <Popup data-id="element-219">
              <div className="text-sm" data-id="element-220">
                <strong data-id="element-221">{store.name}</strong>
                <br data-id="element-222" />
                Bewertung: {store.score} ⭐
              </div>
            </Popup>
          </CircleMarker>)}
      </MapContainer>

      <MapLegend data-id="element-223" />

      <StoreDetailPanel isOpen={isPanelOpen} onClose={() => setIsPanelOpen(false)} store={selectedStore} data-id="element-224" />
    </div>;
}